import { render, staticRenderFns } from "./scissors.vue?vue&type=template&id=752fc563&"
import script from "./scissors.vue?vue&type=script&lang=js&"
export * from "./scissors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports